import { render } from "./index.vue?vue&type=template&id=2c7e66aa"
const script = {}

const cssModules = {}
import style0 from "./index.vue?vue&type=style&index=0&id=2c7e66aa&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "/Users/mymac/Documents/Digitala/Perki/newest-perki/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__